export default {
  // Main titles
  editProfile: "Edit Profile",
  saveChanges: "Save Changes",
  loadingProfile: "Loading Profile...",
  pleaseWait: "Please wait while we fetch your data",

  // Form fields
  firstName: "First Name",
  lastName: "Last Name",
  emailAddress: "Email address",
  position: "Position",
  contactInformation: "Contact Information",
  city: "City",
  country: "Country",
  state: "State",

  // Phone numbers
  phoneNumbers: "Phone Numbers",
  addPhone: "Add Phone",
  addAnotherPhone: "Add another phone number",
  noPhoneNumbersAdded: "No phone numbers added. Click 'Add Phone' to add one.",
  phone: "Phone",
  phoneNumber: "Phone Number",
  enterPhoneNumber: "Enter phone number",
  removeThisPhoneNumber: "Remove this phone number",
  removePhoneNumber: "Remove phone number",

  // Social links
  links: "Links",
  addLink: "Add Link",
  addAnotherLink: "Add another link",
  selectSocialPlatform: "Select social platform",
  enterProfileUrl: "Enter your profile URL",
  removeThisLink: "Remove this link",
  removeLink: "Remove link",

  // Success messages
  profileUpdatedSuccessfully: "Profile updated successfully!",
  profileImageUpdatedSuccessfully: "Profile image updated successfully!",
  success: "Success",

  // Error messages
  error: "Error",
  validationError: "Validation Error",
  unexpectedError: "An unexpected error occurred",
  failedToLoadProfileData: "Failed to load profile data",
  failedToSaveProfileData: "Failed to save profile data",
  failedToUploadProfileImage: "Failed to upload profile image",
  pleaseCorrectInvalidPhones:
    "Please correct the invalid phone numbers before saving.",

  // ProfileCard
  changePhoto: "Change Photo",
  socialLinks: "Social Links",

  // Upload errors
  uploadError: "Upload Error",
  fileSizeExceedsLimit: "File size exceeds limit of 50MB",
  failedToUploadImage: "Failed to upload image",

  // Buttons
  ok: "OK",
};
